// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"F4jUe","body":"INCrM","body-art":"VqvxE","rc-tabs-bar":"qVeax","rc-tabs-tab":"ikh-3","rc-tabs-tab-active":"fEEFO","footerButton":"_1-cPw"};